import { get } from '../utils/makeRequest';

const SNAPSHOT_ENDPOINTS = {
  GET_SNAPSHOT: '/forex/snapshot', // Fixed: Added /forex prefix
  GET_SYMBOL_DATA: '/forex/snapshot', // Fixed: Added /forex prefix
  FETCH_FRESH: '/fetch-snapshot',
};

export const snapshotService = {
  /**
   * Get snapshot data with API key
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Snapshot data
   */
  getSnapshotData: async (apiKey) => {
    if (!apiKey) {
      throw new Error('API key is required');
    }
    
    const endpoint = `${SNAPSHOT_ENDPOINTS.GET_SNAPSHOT}?apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },

  /**
   * Get symbol-specific data with API key
   * @param {string} symbol - Currency pair symbol
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Symbol data
   */
  getSymbolData: async (symbol, apiKey) => {
    if (!symbol || !apiKey) {
      throw new Error('Symbol and API key are required');
    }
    
    const endpoint = `${SNAPSHOT_ENDPOINTS.GET_SYMBOL_DATA}/${symbol}?apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },

  /**
   * Fetch fresh snapshot data with API key (for regular users)
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Fresh snapshot data
   */
  fetchFreshSnapshotData: async (apiKey) => {
    if (!apiKey) {
      throw new Error('API key is required');
    }
    
    const endpoint = `${SNAPSHOT_ENDPOINTS.GET_SNAPSHOT}?apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },
};